module.exports = __webpack_public_path__ + "img/1-1.29d18f42.jpeg";